(function($){
  'use strict';

  if(!$.tangible){
    $.tangible = new Object();
  };

  $.tangible.notifications = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.init = function(){

      base.$btnToggle = $('.js-toggleNotificationsBtn');
      base.$receiver = $('.js-notificationsBox');
      base.$alert = $('.c-notifications .c-alert');

      // Opens the box of options
      base.$btnToggle.click(function(e){
        e.preventDefault();
        base.$receiver.toggleClass('is-visible');
        base.$alert.toggleClass('is-underskin');
        // Switches the state of aria-expanded
        var expanded = $(this).attr('aria-expanded') === 'true' || false;
        $(this).attr('aria-expanded', !expanded);
        // base.removesOverlay();
      });
      
      // Closes the box when click outside of it
      // $(document).mouseup(function(e) {
      //   if (!base.$receiver.is(e.target) && base.$receiver.has(e.target).length === 0) {
      //     base.$receiver.removeClass('is-visible');
      //     base.$btnToggle.attr('aria-expanded', false);
      //   }
      // });

    };


    base.init();

    base.addsOverlay = function() {
      
    }

  };

  $.fn.tangible_notifications = function(options){
    return this.each(function(){
      (new $.tangible.notifications(this, options));
    });
  };

})(jQuery);